import classNames from 'classnames'
import React, { useEffect, useState } from 'react'

import { TPopupHorizontal } from 'core-components/library/popup'
import { Tooltip } from 'core-components/library/tooltip'

import { useContactCodesStatus } from '../../../../../useHooks/useContactCodesStatus'

import { IContactStatusIconProps } from './models'

import styles from './ContactStatusIcon.module.scss'

export const ContactStatusIcon = ({ contact }: IContactStatusIconProps) => {
  const [indicatorStatus, setIndicatorStatus] = useState('')

  const contactId = contact.get('ContactID')
  const workflowStatus = contact.get('WorkflowStatus')
  const codeStatus = contact.get('ContactCodeStatus')

  const otherCodesStatus = useContactCodesStatus(
    codeStatus && codeStatus !== 'Done' ? contactId : ''
  )

  useEffect(() => {
    if (workflowStatus && workflowStatus !== 'Done') {
      setIndicatorStatus(workflowStatus)
    } else if (codeStatus && codeStatus !== 'Done') {
      setIndicatorStatus(codeStatus)
    } else {
      setIndicatorStatus('')
    }
  }, [contactId, workflowStatus, codeStatus])

  if (!indicatorStatus) {
    return <div className={styles.requestIndicator} />
  }

  return (
    <Tooltip
      className={styles.requestIndicator}
      horizontalStartPosition={TPopupHorizontal.Right}
      horizontalDirection={TPopupHorizontal.Right}
      tipContent={() => (
        <div className={styles.requestIndicatorTipContent}>
          {workflowStatus ? <p>{`Workflow Status: ${workflowStatus}`}</p> : null}
          {codeStatus && !otherCodesStatus ? <p>{`Contact Code Status: ${codeStatus}`}</p> : null}
          {otherCodesStatus ? (
            <>
              {otherCodesStatus['UserRights'] ? (
                <p>{`UserRights Status: ${otherCodesStatus['UserRights']}`}</p>
              ) : null}
              {otherCodesStatus['Campaigns'] ? (
                <p>{`Campaigns Status: ${otherCodesStatus['Campaigns']}`}</p>
              ) : null}
              {otherCodesStatus['Tools'] ? (
                <p>{`Tools Status: ${otherCodesStatus['Tools']}`}</p>
              ) : null}
            </>
          ) : null}
        </div>
      )}
    >
      <div
        className={classNames(
          styles.requestIndicator,
          styles[`requestIndicator${indicatorStatus}`]
        )}
      >
        <div className={styles.requestIndicatorItem} />
      </div>
    </Tooltip>
  )
}
